import { Controller } from '@hotwired/stimulus';
import { useEvent } from '../utils/useEventListener';

export default class extends Controller {
  connect() {
    useEvent(this, 'turbo:before-morph-element', this.beforeMorph);
  }

  beforeMorph(event) {
    console.log(this.element, event);

    if (this.element.hasAttribute('data-morph-disable')) {
      event.preventDefault();
    }
  }
}
